// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--xBZht","photo":"a10a3f92e9--photo--Uj1Ky"};